import FundUnits from "./FundUnits";

const fundUnits = {
  FundUnits
};

export default fundUnits;
